import LoggerHistory from "@/views/admin/logs/LoggerHistory";

export default {
  path: "logs/history",
  name: "logs-history",
  component: LoggerHistory,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
